import { Box, TextField, Typography } from "@mui/material";
import React from "react";

interface StepProps {
  formik: any;
}

const BecomeSellerFormStep4: React.FC<StepProps> = ({ formik }) => {
  return (
    <Box className="space-y-6">
      <Typography variant="h6" className="text-center font-bold pb-2">
        Business & Login Credentials
      </Typography>

      <div className="space-y-5">
        <TextField
          fullWidth
          name="businessDetails.businessName"
          label="Registered Business / Shop Name"
          value={formik.values.businessDetails?.businessName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched?.businessDetails?.businessName &&
            Boolean(formik.errors?.businessDetails?.businessName)
          }
          helperText={
            formik.touched?.businessDetails?.businessName &&
            formik.errors?.businessDetails?.businessName
          }
        />

        <TextField
          fullWidth
          name="sellerName"
          label="Full Legal Name"
          value={formik.values.sellerName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.sellerName && Boolean(formik.errors.sellerName)
          }
          helperText={
            formik.touched.sellerName && formik.errors.sellerName
          }
        />

        <TextField
          fullWidth
          name="email"
          type="email"
          label="Email Address"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />

        <TextField
          fullWidth
          name="password"
          type="password"
          label="Account Password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
        />
      </div>
    </Box>
  );
};

export default BecomeSellerFormStep4;